import { createSelector } from 'redux-starter-kit';

const fundsAndMpsRefSelector = (state: any) => {
  return state.fundsAndMpsRef;
};

export const fundsAndMpsRefSelectors = {
  getFundsAndMpsRef: createSelector(
    fundsAndMpsRefSelector,
    subState => subState.fundsAndMpsRef
  )
};
